import { render, staticRenderFns } from "./UsersCreateForm.vue?vue&type=template&id=04c90444&scoped=true&"
import script from "./UsersCreateForm.vue?vue&type=script&lang=js&"
export * from "./UsersCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./UsersCreateForm.vue?vue&type=style&index=0&id=04c90444&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c90444",
  null
  
)

export default component.exports